/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../i18n';

export const useDocumentTitle = (title?: string) => {
  const { t } = useTranslation(Namespaces.Common);
  useEffect(() => {
    document.title = title
      ? t(`document_title.title`, 'Hosting', { page_title: title })
      : t(`document_title.app_name`, 'Hosting');
    return () => {
      document.title = t(`document_title.app_name`, 'Hosting');
    };
  }, [t, title]);
};
